import * as React from "react";
import {useEffect, useState, createContext} from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import EventExpandMore from "./EventExpandMore";
import EventExpandLess from "./EventExpandLess";
import {withCommentContext} from "./commentContext";
import {withLikeStatusContext} from "./likeStatusContext";
import {withLikeCountContext} from "./likeCountContext";
import {withEventContext} from "./eventContext";
import {Box} from "@mui/material";
import {useDarkMode} from "../darkMode/hook/useDarkMode";


const EventDetailCardRender = ({theEvent, id}) => {
    const [expandMore, setExpandMore] = useState(false);
    const handleToggleClick = () => {
        setExpandMore(!expandMore)
    };
    const {mode} = useDarkMode();

    return (
        <Paper
            sx={{
                p: 2,
                margin: 'auto',
                flexGrow: 1,
                boxShadow: '4px 3px 8px 1px #9696966b',
                marginBottom: 3,
                width: '-webkit-fill-available',
                backgroundColor: `${mode.settings.cardBackgroundColor} !important`
            }}

            id={id}
        >
            {theEvent.hasOwnProperty('id') ?
                <Box >
                    {
                        expandMore
                            ?
                            <EventExpandMore
                                theEvent={theEvent}
                                expandMore={expandMore}
                                handleToggleClick={handleToggleClick}
                            />
                            :
                            <EventExpandLess
                                theEvent={theEvent}
                                expandMore={expandMore}
                                handleToggleClick={handleToggleClick}
                            />
                    }
                </Box>
                :''
            }
        </Paper>
    )
}

export default withLikeCountContext(
        withLikeStatusContext(
            withCommentContext(
                EventDetailCardRender
            )
        )
    );
